import cls from "./BlogCtaBanner.module.css";
import { Button } from "@/components/UI/Button/Button";
import { CALENDAR_URL } from "@/utils/consts";

interface BlogCtaBannerProps {
    title: string;
    subtitle: string;
    buttonText: string;
    href?: string;
}

export const BlogCtaBanner = ({ title, subtitle, buttonText, href = CALENDAR_URL }: BlogCtaBannerProps) => {
    return (
        <div className={cls.banner}>
            <div className={cls.text}>
                <p className={cls.title}>{title}</p>
                <p className={cls.subtitle}>{subtitle}</p>
            </div>

            <Button className={cls.button} href={href} target={href !== CALENDAR_URL}>
                {buttonText}
            </Button>
        </div>
    );
};
